import BloggerStudyAi from "./BloggerStudyAi";

export default BloggerStudyAi;